import navigate from 'utils/navigate'

export const forwardParams = path => `${path}${window.location.search}`

export const navigateTo = path => () => navigate(path)

export const isAdminPathname = pathname => pathname.startsWith('/admin')

export const roundDownToNearest = (n, chunk = 10) =>
  parseInt(n / chunk, 10) * chunk

export const displayRoundedNumber = (n, chunk, withSufix = true, locale) => {
  const roundedNumber = roundDownToNearest(n, chunk).toLocaleString(locale)
  return withSufix ? `${roundedNumber}+` : `${roundedNumber}`
}

export const pluralize = (n, single, multiple) => (+n === 1 ? single : multiple)

export const parseCookies = str =>
  str
    .split(';')
    .map(v => v.split('='))
    .reduce((acc, v) => {
      try {
        acc[decodeURIComponent(v[0].trim())] = JSON.parse(
          decodeURIComponent(v[1].trim()),
        )
      } catch {
        acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1].trim())
      }
      return acc
    }, {})

export default { navigateTo, forwardParams, isAdminPathname }
